import Check from "@mui/icons-material/Check";
import ListIcon from "@mui/icons-material/FormatListBulleted";
import Reorder from "@mui/icons-material/Reorder";
import SegmentIcon from "@mui/icons-material/Segment";
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  SvgIconProps,
  Tooltip,
} from "@mui/material";
import { ComponentType, useState } from "react";

/** How the list view lays out tasks: every occurrence, or one row per series. */
export type ListMode = "list" | "series";

const LIST_MODES: { value: ListMode; label: string; Icon: ComponentType<SvgIconProps> }[] = [
  { value: "series", label: "List by series", Icon: SegmentIcon },
  { value: "list", label: "List by date", Icon: ListIcon },
];

type ListModeButtonProps = {
  value: ListMode;
  onChange: (listMode: ListMode) => void;
};

/** Toolbar icon button that opens a menu for choosing the list view's {@link ListMode}. */
export const ListModeButton = ({ value, onChange }: ListModeButtonProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const close = () => setAnchorEl(null);

  return (
    <>
      <Tooltip title="List mode">
        <IconButton
          size="medium"
          color="info"
          aria-label="List mode"
          aria-haspopup="menu"
          aria-expanded={anchorEl ? "true" : undefined}
          onClick={(event) => setAnchorEl(event.currentTarget)}
        >
          <Reorder />
        </IconButton>
      </Tooltip>
      <Menu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={close}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        // Prevent the menu from affecting body scroll, which triggers DataGrid's ResizeObserver
        disableScrollLock
      >
        {LIST_MODES.map(({ value: mode, label, Icon }) => (
          <MenuItem
            key={mode}
            selected={mode === value}
            onClick={() => {
              onChange(mode);
              close();
            }}
            sx={{ minWidth: 220 }}
          >
            <ListItemIcon>
              <Icon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{label}</ListItemText>
            {mode === value && <Check fontSize="small" color="primary" sx={{ ml: 2 }} />}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
